import { render, staticRenderFns } from "./BusinessMatrix.vue?vue&type=template&id=8ffa4b9a&scoped=true"
import script from "./BusinessMatrix.vue?vue&type=script&lang=js"
export * from "./BusinessMatrix.vue?vue&type=script&lang=js"
import style0 from "./BusinessMatrix.vue?vue&type=style&index=0&id=8ffa4b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffa4b9a",
  null
  
)

export default component.exports